jQuery(document).ready(function () {
  // Readonly vs Disable field differences described here: http://stackoverflow.com/a/7730719/634386
  // Readonly Fields
  jQuery('.gf_readonly textarea, .gf_readonly input').attr('readonly', 'readonly');
  jQuery('.gf_readonly select option').each(function () {
    if (this.selected && (this.text !== '--' || this.text !== '')) {
      jQuery(this).parent().attr('readonly', 'readonly').trigger('chosen:updated');
    }
  });
  // Disabled Fields
  jQuery('.gf_disabled textarea, .gf_disabled input').attr('disabled','disabled');
  jQuery('.gf_disabled select option').each(function() {
    if (this.selected && this.text !== '--' && this.text !== '') {
      jQuery(this).parent().attr('disabled','disabled');
    }
  });
});

// MailCheck for Email Fields
jQuery('.gfield input[type="email"]').after('<div class="suggestion"></div>');
// var extra_domains = Mailcheck.defaultSecondLevelDomains.push('smartstartinc', 'smartstartcanada');
jQuery('.gfield input[type="email"]').on('blur', function() {
  var elem = jQuery(this);
  var suggestion_elem = jQuery(this).siblings('div.suggestion');
  jQuery(this).mailcheck({
    suggested: function(element, suggestion) {
      // suggestion callback code
      elem.addClass('has_sugg');
      suggestion_elem.html("<span class='dismiss'>x</span>Did you mean:<br><span class='change_email'>" + suggestion.full + "</span>");
      jQuery('.gfield input[type="email"]+div.suggestion>span.change_email').on('click', function() {
        elem.removeClass('has_sugg').val(suggestion.full);
        suggestion_elem.html("");
      });
      jQuery('.gfield input[type="email"]+div.suggestion>span.dismiss').on('click', function() {
        elem.removeClass('has_sugg');
        suggestion_elem.html("");
      });
    },
    empty: function(element) {
      // empty callback code
      elem.removeClass('has_sugg');
      suggestion_elem.html("");
    }
  });
});